import React from 'react';
import './FilterTabs.css';

const FilterTabs = ({ activeTab, onTabChange, statusCounts }) => {
  const tabs = [
    { id: 'All', label: 'All Orders' },
    { id: 'New', label: 'New', count: statusCounts?.New || 0 },
    { id: 'Preparing', label: 'Preparing' },
    { id: 'Ready', label: 'Ready' },
    { id: 'Delivered', label: 'Delivered' },
    { id: 'Cancelled', label: 'Cancelled' }
  ];

  return (
    <div className="filter-tabs">
      {tabs.map(tab => (
        <button
          key={tab.id}
          className={`filter-tab ${activeTab === tab.id ? 'active' : ''}`}
          onClick={() => onTabChange(tab.id)}
        >
          {tab.label}
          {tab.count !== undefined && tab.count > 0 && (
            <span className="tab-badge">{tab.count}</span>
          )}
        </button>
      ))}
    </div>
  );
};

export default FilterTabs;

